<template>
  <div class="min-h-screen bg-lighter-gray">
    <div class="bg-white py-4 lg:bg-lighter-gray">
      <div class="table-max m-auto mt-4 px-6">
        <div class="flex items-center justify-between">
          <div class="flex flex-col items-start">
            <h1 class="text-left text-2xl text-dark-blue">{{ title }}</h1>
            <p v-if="isDesktop && isLoadsDashboard && !doesNotMeetRequirements">
              {{ numberOfLoadsOnLoadBoard }}
            </p>
          </div>

          <div
            v-if="isLoadsDashboard && isDesktop"
            class="flex cursor-pointer items-center gap-2 rounded-md bg-light-gray px-3 py-1 text-sm"
            @click="handleRefreshView"
          >
            <svg
              class="ml-1 h-5 w-5"
              :class="{ 'spin-quick': resetActive }"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                clip-rule="evenodd"
              ></path>
            </svg>

            <p>Refresh View</p>

            <svg
              class="rotate-90"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 5L0.749999 0.669874L0.749999 9.33013L6 5Z"
                fill="#6C7C9D"
              />
            </svg>
          </div>
        </div>

        <LoadsSearchAndFilter
          v-if="!isDesktop"
          placeholder="Search Loads"
          :is-loads-dashboard="isLoadsDashboard"
          @search-loads="searchLoadsInput"
        ></LoadsSearchAndFilter>

        <div
          v-if="tabs?.length"
          class="mt-2 flex w-full justify-between pt-4 lg:w-[300px] lg:px-0"
        >
          <span
            v-for="tab in tabs"
            :key="tab.title"
            class="mx-4 flex-1 cursor-pointer"
            :class="
              currentTab === tab.title
                ? 'border-b-2 border-neutral-subtle-yellow text-base font-semibold text-neutral-subtle-yellow'
                : 'text-gray text-base'
            "
            @click="handleTabSelection(tab.title)"
          >
            <p class="capitalize">
              {{ tab.title }}
            </p>
          </span>
        </div>
      </div>
    </div>

    <div class="table-max m-auto">
      <div
        v-if="isLoadsDashboard && !isDesktop"
        class="max-w-screen ml-6 mt-4 flex justify-between gap-3 overflow-scroll sm:mx-6"
      >
        <!-- <button-main
          variant="tertiary"
          class="flex !h-[48px] min-w-max max-w-[160px] items-center justify-center gap-2 border border-gray-200 !bg-white !p-3 text-1md !font-medium !text-neutral-subtle-bold"
          @click="handleLoadSort"
        >
          <img
            src="@/assets/arrows-up-and-down.svg"
            alt="arrows icon"
          />
          Sort: {{ postingSort === 'asc' ? 'Oldest' : 'Latest' }}
        </button-main> -->

        <!-- <LoadFilterButtons
          :white-bg="true"
          :is-scrollable="false"
        ></LoadFilterButtons> -->
      </div>

      <div
        v-if="!isDesktop"
        class="flex items-center justify-between px-6"
      >
        <div
          v-if="!doesNotMeetRequirements"
          class="w-full"
        >
          <p v-if="isLoading"></p>
          <p
            v-else-if="!isLoadsDashboard"
            class="w-max"
          >
            {{ numberOfLoads }}
          </p>
          <div
            v-else
            class="flex justify-between gap-3"
          >
            <p class="text-left">{{ numberOfLoadsOnLoadBoard }}</p>

            <div v-if="loads?.length > 0">
              <button-main
                variant="tertiary"
                class="flex !h-[48px] min-w-max max-w-[160px] items-center justify-center gap-2 border border-gray-200 !bg-white !px-2 !py-3 text-1md !font-medium !text-neutral-subtle-bold"
                @click="openSortBottomSheet"
              >
                <img
                  src="@/assets/arrows-up-and-down.svg"
                  alt="arrows icon"
                />
                Sort: {{ postingSort }}
              </button-main>
            </div>
          </div>
        </div>

        <div
          v-if="!isLoadsDashboard"
          class="flex min-w-max cursor-pointer gap-1"
          @click="openSortBottomSheet"
        >
          <img
            src="@/assets/sort-arrows.svg"
            alt="sort icon"
          />
          Sort by
        </div>
      </div>

      <div v-if="isDesktop">
        <div class="flex flex-row pb-16">
          <LoadFiltersDesktop
            :is-loads-dashboard="isLoadsDashboard"
            :is-resetting-search="isResettingSearch"
          ></LoadFiltersDesktop>

          <div
            v-if="isLoading"
            class="mt-16 flex max-h-[400px] w-full items-center justify-center rounded-lg border-2 border-light-gray bg-white"
          >
            <div>
              <img
                class="loading m-auto h-12 w-12"
                src="@/assets/loading-v2-yellow.svg"
                alt="loading spinner"
              />
              <p class="mt-2 text-base">Loading</p>
            </div>
          </div>

          <div
            v-else-if="doesNotMeetRequirements"
            class="m-auto mt-16 flex h-min w-[500px] flex-col gap-3 rounded-lg border border-light-gray bg-white p-4 shadow-md"
          >
            <h3
              class="text-left text-xl font-semibold text-neutral-subtle-bold"
            >
              Let's get you on the road.
            </h3>
            <p class="text-left font-normal text-neutral-subtle-bold">
              {{ loadErrorMessage }}
            </p>

            <div class="mt-4 flex gap-4">
              <button-main
                class="!h-[48px] !py-3 text-1md !text-dark-gray"
                @click="handleLearnMore"
              >
                Learn More
              </button-main>
              <button-main
                class="!h-[48px] !py-3 text-1md !text-dark-gray"
                variant="tertiary"
                @click="handleResetSearch"
              >
                Reset Search
              </button-main>
            </div>
          </div>

          <div
            v-else-if="loads?.length === 0"
            class="mt-16 flex h-[400px] w-full flex-col items-center justify-center rounded-lg border-2 border-light-gray bg-white"
          >
            <img
              class="h-20 w-20"
              src="@/assets/magnify.svg"
              alt=""
            />

            <h3 class="text-center text-lg text-gray-400">No results found.</h3>
          </div>

          <div
            v-else-if="isLoadsDashboard"
            class="mt-12 h-min w-full rounded-md border-2 border-light-gray bg-white"
          >
            <div
              class="grid grid-cols-20 border-l border-r border-transparent px-2 py-2 text-left font-semibold"
            >
              <p class="col-span-3 text-xs">Broker</p>
              <p class="col-span-3 text-xs">Origin</p>
              <p class="col-span-3 text-xs">Destination</p>
              <div
                class="col-span-2 flex cursor-pointer hover:opacity-60"
                @click="handleTripSort"
              >
                <p class="text-xs">Trip</p>
                <img
                  class="ml-2 h-4"
                  :class="tripSort === 'asc' ? 'icon-flip' : ''"
                  src="@/assets/arrow-down-black.svg"
                  alt="arrow icon"
                />
              </div>
              <p class="col-span-2 text-xs">Equipment</p>
              <p class="col-span-2 text-xs">Weight</p>
              <p class="col-span-2 text-xs">Certifications</p>
              <div
                class="col-span-3 flex cursor-pointer hover:opacity-60"
                @click="handlePriceSort"
              >
                <p class="text-xs">Rate</p>
                <img
                  class="ml-2 h-4"
                  :class="priceSort === 'asc' ? 'icon-flip' : ''"
                  src="@/assets/arrow-down-black.svg"
                  alt="arrow icon"
                />
              </div>
            </div>

            <div class="">
              <div
                v-for="load in loads"
                :key="load.id"
                class="grid grid-cols-20 border-t-2 border-light-gray px-2 font-normal text-neutral-subtle hover:bg-gray-50"
              >
                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-3 flex flex-col items-start justify-center gap-1 py-3"
                >
                  <BrokerImage
                    :image-src="load?.broker_logo?.url"
                    :broker-name="load?.broker_name"
                  >
                  </BrokerImage>

                  <p class="text-1xs text-neutral-subtle">
                    Posted {{ fromNowFirstUnit(load.last_posted_at) }} ago
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-3 flex flex-col justify-center py-3 text-start"
                >
                  <p class="min-w-fit text-xs">
                    {{ loadOrigin(load) }}
                  </p>

                  <p class="text-xs font-normal text-neutral-subtlest">
                    {{ formatStopDate(load?.pickup_time) }}
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-3 flex flex-col justify-center py-3 text-start"
                >
                  <p class="min-w-fit text-xs">
                    {{ loadDestination(load) }}
                  </p>

                  <p class="text-xs text-neutral-subtlest">
                    {{ formatStopDate(load?.dropoff_time) }}
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-start py-3"
                >
                  <p class="text-xs">{{ load.billable_miles }} mi</p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-start py-3"
                >
                  <p class="text-xs capitalize">
                    {{ formatEquipmentType(load.posted_equipment_types?.[0]) }}
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-start py-3"
                >
                  <p class="text-xs">
                    {{ loadWeight(load.weight, load.weight_unit) }}
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-start py-3"
                >
                  <!-- TODO -------------->
                  <p
                    class="w-max rounded-md bg-light-gray px-2 text-xs font-medium capitalize text-neutral-subtle-bold"
                  >
                    None
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-3 flex items-center py-3"
                >
                  <div class="flex w-full items-center justify-between">
                    <span
                      class="rounded px-[6px] py-[2px] text-xs"
                      :class="{
                        'bg-[#136782] text-white':
                          formatLoadRate(load?.rate_per_mile) === 'Great Deal',
                        'bg-[#18A5CB] text-white':
                          formatLoadRate(load?.rate_per_mile) === 'Good Deal',
                        'bg-[#2AC6E8] text-neutral-boldest':
                          formatLoadRate(load?.rate_per_mile) === 'Fair Deal',
                        'bg-green-500':
                          formatLoadRate(load?.rate_per_mile) ===
                          'Above Market',
                        'bg-red-100 text-red-600':
                          formatLoadRate(load?.rate_per_mile) ===
                          'Below Market',
                      }"
                      >{{ formatLoadRate(load?.rate_per_mile) }}</span
                    >
                    <div class="flex flex-col items-end">
                      <p class="text-xl font-semibold">
                        <!-- TODO -- add badge and per_mile -->
                        {{ formatPrice(load.price, 0) }}
                      </p>
                      <p class="text-xs">${{ load.rate_per_mile }}/mi</p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <section
              v-if="!isLoading && canViewPagination"
              class="flex items-center justify-center py-3"
            >
              <Pagination
                v-if="canViewPagination"
                :selected-page="+loadsPagination.currentPage"
                :total-pages="+loadsPagination.totalPages"
                @select-page="onSelectPage"
              />
            </section>
          </div>

          <div
            v-else
            class="mt-12 w-full"
          >
            <div
              class="grid border-l border-r border-transparent px-2 pb-1 font-semibold"
              :class="{
                'grid-cols-12': currentTab !== 'dispatch',
                'grid-cols-10': currentTab === 'dispatch',
              }"
            >
              <p class="col-span-2 text-xs">Load ID</p>
              <p class="col-span-2 text-xs">Status</p>
              <div
                class="col-span-2 flex cursor-pointer"
                @click="handleOriginSort"
              >
                <p class="text-start text-xs">Load Origin</p>
                <img
                  class="ml-2 h-4"
                  :class="originSort === 'asc' ? 'icon-flip' : ''"
                  src="@/assets/arrow-down-black.svg"
                  alt="arrow icon"
                />
              </div>
              <div
                class="col-span-2 flex cursor-pointer"
                @click="handleDestinationSort"
              >
                <p class="text-start text-xs">Load Destination</p>
                <img
                  class="ml-2 h-4"
                  :class="destinationSort === 'asc' ? 'icon-flip' : ''"
                  src="@/assets/arrow-down-black.svg"
                  alt="arrow icon"
                />
              </div>

              <p
                v-if="currentTab !== 'dispatch'"
                class="col-span-2 text-xs"
              >
                Truck Number
              </p>
              <p
                v-if="currentTab !== 'dispatch'"
                class="col-span-2 text-xs"
              >
                VIN
              </p>
              <p
                v-if="currentTab === 'dispatch'"
                class="col-span-2"
              ></p>
            </div>

            <div class="rounded-md border-2 border-light-gray bg-white">
              <div
                v-for="(load, loadIndex) in loads"
                :key="load.id"
                class="grid px-2 font-normal text-neutral-subtle hover:bg-gray-50"
                :class="{
                  'border-t-2 border-light-gray': loadIndex,
                  'grid-cols-12': currentTab !== 'dispatch',
                  'grid-cols-10': currentTab === 'dispatch',
                }"
              >
                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-center py-3"
                >
                  <p class="w-full break-words px-2 text-xs">
                    {{ load.id }}
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-center py-3"
                >
                  <span
                    class="rounded-full px-2 text-xs font-medium capitalize"
                    :class="{
                      'bg-yellow-100 text-yellow-700':
                        load.status === 'covered',
                      'bg-blue-100 text-blue-500': load.status === 'progress',
                      'bg-green-100 text-green-800':
                        load.status === 'assumed_delivered',
                      'bg-red-150 text-red-500':
                        load.status === 'assign_vehicle' ||
                        load.status === 'available',
                    }"
                  >
                    {{ formatLoadStatus(load.status) }}
                  </span>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex flex-col justify-center py-3 text-start"
                >
                  <p class="min-w-fit text-xs">
                    {{ loadOrigin(load) }}
                  </p>

                  <p class="text-xs font-normal text-neutral-subtlest">
                    {{ formatStopDate(load?.pickup_time) }}
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex flex-col justify-center py-3 text-start"
                >
                  <p class="min-w-fit text-xs">
                    {{ loadDestination(load) }}
                  </p>

                  <p class="text-xs text-neutral-subtlest">
                    {{ formatStopDate(load?.dropoff_time) }}
                  </p>
                </router-link>

                <router-link
                  v-if="load.carrier_vehicle"
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-center py-3"
                >
                  <p class="text-xs">
                    {{ load?.carrier_vehicle?.truck_number || '-' }}
                  </p>
                </router-link>

                <router-link
                  v-if="load.carrier_vehicle"
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-center py-3"
                >
                  <p class="text-xs">{{ load?.carrier_vehicle?.vin || '-' }}</p>
                </router-link>

                <section
                  v-if="!load.carrier_vehicle"
                  class="col-span-2 flex items-center justify-center"
                >
                  <span
                    class="cursor-pointer rounded-full px-2 py-1 text-1md font-medium hover:bg-gray-200"
                    @click="openAssignVehicleBottomSheet"
                  >
                    Assign Vehicle
                  </span>
                </section>
              </div>
            </div>

            <section
              v-if="!isLoading"
              class="flex items-center justify-center py-3"
            >
              <Pagination
                v-if="canViewPagination"
                :selected-page="+loadsPagination.currentPage"
                :total-pages="+loadsPagination.totalPages"
                @select-page="onSelectPage"
              />
            </section>
          </div>
        </div>
      </div>

      <div
        v-else-if="isLoading"
        class="mt-6"
      >
        <img
          class="loading m-auto h-12 w-12"
          src="@/assets/loading-v2-yellow.svg"
          alt="loading spinner"
        />
      </div>

      <div
        v-else-if="doesNotMeetRequirements"
        class="mx-4 flex flex-col gap-3 rounded-lg border border-light-gray bg-white p-4 shadow-md"
      >
        <h3 class="text-left text-lg font-semibold text-neutral-subtle-bold">
          Let's get you on the road.
        </h3>
        <p class="text-left font-normal text-neutral-subtle-bold">
          {{ loadErrorMessage }}
        </p>

        <div class="mt-4 flex flex-col gap-4">
          <button-main
            class="!h-[48px] !py-3 text-1md !text-dark-gray"
            @click="handleLearnMore"
          >
            Learn More
          </button-main>
          <button-main
            class="!h-[48px] !py-3 text-1md !text-dark-gray"
            variant="tertiary"
            @click="handleResetSearch"
          >
            Reset Search
          </button-main>
        </div>
      </div>

      <div
        v-else-if="loads?.length === 0"
        class="m-4 flex flex-col items-center justify-center rounded-lg bg-white py-4"
      >
        <img
          class="h-16 w-16"
          src="@/assets/magnify.svg"
          alt=""
        />

        <h3 class="text-center text-lg text-gray-400">No results found.</h3>
      </div>

      <div
        v-else
        class="grid h-full grid-cols-4 gap-3 p-4"
      >
        <div
          v-for="load in loads"
          :key="load.id"
          class="col-span-4 px-2 md:col-span-2"
        >
          <LoadDetail
            :load="load"
            :is-loads-dashboard="isLoadsDashboard"
          ></LoadDetail>
        </div>

        <InfiniteScroll @loadMore="loadMoreDetails"></InfiniteScroll>
      </div>
      <div
        v-if="isLoadsRefetching && !isLoading"
        class="pb-12 pt-6"
      >
        <img
          class="loading m-auto h-12 w-12"
          src="@/assets/loading-v2-yellow.svg"
          alt="loading spinner"
        />
      </div>
    </div>
  </div>

  <LoadSortBottomSheet
    :visible="showSortBottomSheet"
    :is-loads-dashboard="isLoadsDashboard"
    @close="closeSortBottomSheet"
  >
  </LoadSortBottomSheet>
  <AssignVehicleBottomSheet
    :visible="showAssignVehicleBottomSheet"
    @close="closeAssignVehicleBottomSheet"
    @assign-vin="handleAssignVin"
  >
  </AssignVehicleBottomSheet>
  <ELDVehicleReportModal
    :visible="showEldVehicleReportModal"
    @close="closeEldVehicleReportModal"
  >
  </ELDVehicleReportModal>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import LoadDetail from '@/components/loads/LoadDetail.vue';
import LoadFiltersDesktop from '@/components/loads/LoadFiltersDesktop.vue';
import LoadsSearchAndFilter from '@/components/loads/LoadsSearchAndFilter.vue';
import LoadSortBottomSheet from '@/components/loads/LoadSortBottomSheet.vue';
import AssignVehicleBottomSheet from '@/components/loads/AssignVehicleBottomSheet.vue';
import ELDVehicleReportModal from '@/components/loads/ELDVehicleReportModal.vue';
// import LoadFilterButtons from '@/components/loads/LoadFilterButtons.vue';
import BrokerImage from '@/components/loads/BrokerImage.vue';
import Pagination from '@/components/Pagination.vue';
import InfiniteScroll from '@/components/InfiniteScroll.vue';
import ButtonMain from '@/components/Button.vue';
import { formatPrice } from '@/utils/currency';
import {
  formatStopDate,
  formatLoadStatus,
  formatEquipmentType,
  formatLoadRate,
} from '@/utils/loadBoardUtils.js';
import { fromNowFirstUnit } from '@/common/timestamps';

export default {
  name: 'List View',
  components: {
    LoadsSearchAndFilter,
    LoadDetail,
    LoadFiltersDesktop,
    LoadSortBottomSheet,
    Pagination,
    InfiniteScroll,
    AssignVehicleBottomSheet,
    ButtonMain,
    ELDVehicleReportModal,
    BrokerImage,
  },
  props: {
    title: String,
    loads: Array,
    isDesktop: Boolean,
    tabs: Array,
    handleTabSelection: Function,
    currentTab: String,
    isLoading: Boolean,
    isLoadsRefetching: Boolean,
  },
  emits: ['search-loads', 'fetch-more', 'select-page'],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const showSortBottomSheet = ref(false);

    const isLoadsDashboard = computed(() => props.title !== 'My Loads');

    // const loadSearchFilters = computed(
    //   () => store.state.loads?.loadSearchFilters
    // );

    const loadErrorMessage = computed(
      () => store.state.loads?.search_load_error?.message
    );

    const doesNotMeetRequirements = computed(
      () => Object.entries(store.state.loads?.search_load_error)?.length > 0
    );

    const resetActive = ref(false);

    const handleRefreshView = async () => {
      console.log('Refresh layout view:');
      resetActive.value = true;

      const existingQuery = router.currentRoute?.value?.query;
      const existingSort = existingQuery?.sort || '';
      const query =
        JSON.parse(localStorage.getItem('load_search_filters')) || {};

      await store.dispatch('loads/searchLoads', {
        query,
        sort: existingSort,
      });
    };

    watch(
      () => props?.isLoading,
      (newValue) => {
        if (!newValue) {
          resetActive.value = false;
        }
      }
    );

    const routerLinkName = computed(() =>
      isLoadsDashboard?.value ? 'Load Board Detail' : 'Load Detail'
    );

    const loadsPagination = computed(() =>
      isLoadsDashboard.value
        ? store.state.loads?.loadboard_pagination
        : store.state.loads?.[`${props?.currentTab}_pagination`]
    );

    const canViewPagination = computed(
      () => +loadsPagination?.value?.totalRecords > 50
    );

    const numberOfLoads = computed(() => {
      if (!props.loads) {
        return 'no loads';
      } else if (props.loads?.length === 1) {
        return '1 load';
      } else {
        return `${props.loads?.length} loads`;
      }
    });

    const numberOfLoadsOnLoadBoard = computed(() => {
      if (!props.loads) {
        return '';
      } else if (props.loads?.length) {
        return `Showing ${props.loads?.length} of ${loadsPagination?.value?.totalRecords} loads you're eligible for`;
      }

      return '';
    });

    const showEldVehicleReportModal = ref(false);

    const closeEldVehicleReportModal = () => {
      showEldVehicleReportModal.value = false;
    };

    const showAssignVehicleBottomSheet = ref(false);

    const openAssignVehicleBottomSheet = () => {
      showAssignVehicleBottomSheet.value = true;
    };

    const closeAssignVehicleBottomSheet = () => {
      showAssignVehicleBottomSheet.value = false;
    };

    const handleAssignVin = (vin) => {
      console.log('clicked vin: ', vin);
      showEldVehicleReportModal.value = true;
    };

    const openSortBottomSheet = () => {
      showSortBottomSheet.value = true;
    };

    const closeSortBottomSheet = () => {
      showSortBottomSheet.value = false;
    };

    const searchLoadsInput = (term) => {
      emit('search-loads', term);
    };

    const loadMoreDetails = () => {
      emit('fetch-more');
    };

    const onSelectPage = (page) => {
      emit('select-page', page);
    };

    const capitalizeWords = (word) => {
      return word
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
        .replace('Llc', 'LLC');
    };

    const loadOrigin = (load) => {
      const city = capitalizeWords(
        load?.origin?.city || load?.origin?.area_five_zip_city || ''
      );
      const state =
        load?.origin?.state || load?.origin?.area_five_zip_state || '';

      if (!city) {
        return '-';
      }

      return `${city}, ${state}`;
    };

    const loadDestination = (load) => {
      const city = capitalizeWords(
        load?.destination?.city || load?.destination?.area_five_zip_city || ''
      );
      const state =
        load?.destination?.state ||
        load?.destination?.area_five_zip_state ||
        '';

      if (!city) {
        return '-';
      }

      return `${city}, ${state}`;
    };

    const priceSort = computed(() => {
      const sortQuery = router.currentRoute.value.query?.sort;
      const [key, value] = sortQuery?.split('_') || [];

      if (key === 'price') {
        return value;
      } else {
        return 'desc';
      }
    });

    const handlePriceSort = () => {
      const sortDirection = priceSort.value === 'asc' ? 'desc' : 'asc';
      console.log('New Sort Direction: ', sortDirection);

      router.push({
        query: {
          ...router.currentRoute.value.query,
          sort: `price_${sortDirection}`,
        },
      });
    };

    const tripSort = computed(() => {
      const sortQuery = router.currentRoute.value.query?.sort;
      const [key, value] = sortQuery?.split('_') || [];

      if (key === 'distance') {
        return value;
      } else {
        return 'desc';
      }
    });

    const handleTripSort = () => {
      const sortDirection = tripSort.value === 'asc' ? 'desc' : 'asc';
      console.log('New Sort Direction: ', sortDirection);

      router.push({
        query: {
          ...router.currentRoute.value.query,
          sort: `distance_${sortDirection}`,
        },
      });
    };

    const originSort = computed(() => {
      const sortQuery = router.currentRoute.value.query?.sort;
      const [key, value] = sortQuery?.split('_') || [];

      if (key === 'origin') {
        return value;
      } else {
        return 'desc';
      }
    });

    const handleOriginSort = () => {
      if (isLoadsDashboard?.value) {
        return;
      }
      const sortDirection = originSort.value === 'asc' ? 'desc' : 'asc';
      console.log('New Sort Direction: ', sortDirection);

      router.push({
        query: {
          ...router.currentRoute.value.query,
          sort: `origin_${sortDirection}`,
        },
      });
    };

    const destinationSort = computed(() => {
      const sortQuery = router.currentRoute.value.query?.sort;
      const [key, value] = sortQuery?.split('_') || [];

      if (key === 'destination') {
        return value;
      } else {
        return 'desc';
      }
    });

    const handleDestinationSort = () => {
      if (isLoadsDashboard?.value) {
        return;
      }
      const sortDirection = destinationSort.value === 'asc' ? 'desc' : 'asc';

      router.push({
        query: {
          ...router.currentRoute.value.query,
          sort: `destination_${sortDirection}`,
        },
      });
    };

    const handleLearnMore = () => {
      console.log('Learn More');
      //  window.open(
      //     store.state.loads?.search_load_error?.redirect_link,
      //     '_blank'
      //   );
    };

    const isResettingSearch = ref(false);

    const handleResetSearch = async () => {
      isResettingSearch.value = true;

      await store.commit('loads/setLoadSearchFilters', {});
      await store.commit('loads/setSearchLoadError', {});
      await store.commit('laneSearches/setAutocompleteResults', {
        results: [],
        isType: 'origin',
      });
      await store.commit('laneSearches/setAutocompleteResults', {
        results: [],
        isType: 'destination',
      });
      await router.push({
        query: {},
      });

      isResettingSearch.value = false;
    };

    const querySort = computed(
      () => router.currentRoute?.value?.query?.sort || ''
    );

    const sortHash = {
      rpm: 'RPM',
      posting_desc: 'Posting',
      price_desc: 'Price',
      distance_asc: 'Distance Asc',
      distance_desc: 'Distance Desc',
      deadhead: 'Deadhead',
    };

    const postingSort = computed(() =>
      querySort?.value ? sortHash[querySort?.value] : 'Latest'
    );

    const handleImageError = (event) => {
      event.target.src = '';
    };

    const weightUnit = {
      pound: 'lbs',
      kilogram: 'kg',
    };

    const loadWeight = (weight, weight_unit) => {
      return `${weight?.toLocaleString('en-US')} ${weightUnit[weight_unit]}`;
    };

    return {
      showAssignVehicleBottomSheet,
      openAssignVehicleBottomSheet,
      closeAssignVehicleBottomSheet,
      doesNotMeetRequirements,
      numberOfLoads,
      numberOfLoadsOnLoadBoard,
      loadsPagination,
      canViewPagination,
      showSortBottomSheet,
      openSortBottomSheet,
      closeSortBottomSheet,
      searchLoadsInput,
      loadMoreDetails,
      onSelectPage,
      handleDestinationSort,
      handleOriginSort,
      destinationSort,
      originSort,
      isLoadsDashboard,
      routerLinkName,
      handleLearnMore,
      handleResetSearch,
      postingSort,
      formatPrice,
      priceSort,
      handlePriceSort,
      loadOrigin,
      loadDestination,
      formatStopDate,
      formatLoadRate,
      formatLoadStatus,
      formatEquipmentType,
      fromNowFirstUnit,
      handleAssignVin,
      showEldVehicleReportModal,
      closeEldVehicleReportModal,
      handleImageError,
      loadErrorMessage,
      loadWeight,
      resetActive,
      handleRefreshView,
      isResettingSearch,
      tripSort,
      handleTripSort,
    };
  },
};
</script>

<style>
.icon-flip {
  transform: scale(-1);
}

.table-max {
  max-width: 92rem;
}
</style>
